import * as React from "react";

const SvgOscilloscope = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
    {/* <path d="M1505 5106 c-16 -7 -57 -42 -90 -77 -487 -521 -548 -1321 -148 -1916
71 -105 189 -239 227 -257 103 -49 216 21 216 134 0 51 -10 69 -87 153 -149
163 -264 400 -304 627 -19 106 -16 345 5 445 52 240 159 450 321 624 55 60 65
80 65 134 0 105 -109 175 -205 133z"/>
<path d="M3483 5100 c-30 -15 -48 -34 -62 -64 -37 -76 -24 -120 69 -222 344
-380 420 -937 189 -1396 -54 -107 -103 -179 -194 -284 -87 -99 -98 -132 -69
-202 25 -60 71 -92 131 -92 61 0 90 18 167 102 178 195 306 446 368 725 19 84
22 129 22 313 0 201 -1 223 -28 335 -60 259 -164 466 -337 672 -38 45 -83 91
-100 104 -45 31 -104 35 -156 9z"/>
<path d="M1845 4666 c-62 -27 -181 -180 -237 -305 -94 -205 -105 -475 -30
-691 51 -147 165 -315 251 -367 98 -61 221 10 221 128 0 49 -7 62 -89 161 -95
115 -136 245 -129 418 4 99 9 126 36 195 18 46 55 109 85 148 98 128 97 127
97 176 0 61 -29 107 -83 131 -49 23 -81 24 -122 6z"/>
<path d="M3155 4666 c-71 -31 -110 -120 -82 -187 8 -19 37 -61 66 -94 131
-152 181 -365 131 -559 -24 -97 -65 -173 -140 -265 -72 -88 -82 -129 -50 -196
36 -74 117 -103 193 -71 93 38 238 266 288 451 33 118 33 346 1 465 -31 116
-99 249 -177 348 -89 112 -153 142 -230 108z"/>
<path d="M2418 4421 c-250 -80 -386 -357 -296 -600 43 -116 122 -202 233 -256
312 -153 665 68 665 416 0 213 -148 402 -351 448 -69 16 -187 12 -251 -8z
m222 -302 c72 -40 100 -138 64 -215 -47 -99 -181 -119 -260 -40 -106 106 -35
275 115 276 26 0 58 -8 81 -21z"/>
<path d="M485 2718 c-83 -15 -189 -73 -255 -137 -67 -66 -123 -169 -140 -260
-6 -34 -10 -391 -10 -965 0 -993 -1 -965 57 -1086 34 -70 141 -177 213 -212
125 -62 -18 -58 2201 -58 1307 0 2045 4 2080 10 130 24 270 125 337 241 70
124 67 70 67 1109 0 1003 1 973 -52 1088 -35 74 -149 189 -223 225 -122 60
-12 57 -2210 56 -1221 -1 -2035 -5 -2065 -11z m4100 -299 c55 -15 101 -52 128
-102 l22 -42 3 -880 c2 -615 -1 -895 -9 -933 -13 -63 -55 -117 -114 -143 -38
-18 -127 -19 -2049 -19 -1558 0 -2018 3 -2050 12 -52 16 -108 72 -124 124 -9
31 -12 258 -12 935 0 849 1 896 19 934 24 51 68 93 117 110 33 12 366 14 2034
15 1413 0 2007 -3 2035 -11z"/>
<path d="M786 2120 c-16 -5 -40 -19 -54 -32 -53 -49 -52 -38 -52 -725 0 -622
0 -638 21 -679 15 -31 32 -48 63 -63 40 -20 60 -21 347 -21 269 0 308 2 339
18 107 53 107 211 0 264 -30 16 -65 18 -252 18 l-218 0 0 559 0 558 -22 33
c-44 65 -107 90 -172 70z"/>
<path d="M1784 2110 c-25 -12 -49 -35 -62 -59 -22 -39 -22 -40 -22 -686 0
-713 -2 -691 62 -736 72 -52 179 -25 218 55 20 43 20 52 18 694 -3 639 -3 651
-24 678 -51 68 -122 89 -190 54z"/>
<path d="M2314 2111 c-51 -23 -84 -74 -84 -129 0 -34 326 -1143 376 -1280 40
-108 207 -127 267 -30 8 13 101 311 207 662 185 616 192 640 180 680 -17 55
-65 102 -116 110 -51 9 -117 -16 -144 -54 -11 -15 -70 -193 -131 -396 -61
-203 -115 -375 -118 -382 -4 -7 -58 156 -121 362 -62 207 -121 390 -132 406
-19 32 -86 70 -123 70 -11 0 -38 -9 -61 -19z"/>
<path d="M3540 2107 c-84 -44 -80 -6 -80 -740 0 -712 -2 -693 61 -738 l34 -24
370 -3 c337 -2 373 -1 405 15 107 55 107 212 0 265 -31 16 -68 18 -302 18
l-268 0 0 195 0 195 228 0 c202 0 231 2 262 19 107 56 107 210 0 263 -30 16
-66 18 -262 18 l-228 0 0 120 0 120 280 0 c302 0 310 1 359 54 19 20 26 40 28
84 5 72 -19 115 -80 142 -39 18 -69 20 -403 20 -356 0 -361 0 -404 -23z"/> */}
<path d="M393 5106 c-183 -45 -344 -210 -382 -394 -16 -75 -16 -4229 0 -4304
39 -189 208 -358 397 -397 75 -16 4229 -16 4304 0 189 39 358 208 397 397 16
75 16 4229 0 4304 -39 189 -208 358 -397 397 -81 17 -4248 14 -4319 -3z m4358
-189 c67 -32 141 -108 172 -174 l22 -48 3 -2047 2 -2048 -1670 0 c-1783 0
-1716 2 -1734 -45 -15 -39 -6 -83 20 -104 l27 -21 1668 0 c1493 0 1669 -2
1669 -15 0 -29 -48 -110 -87 -146 -52 -48 -81 -65 -144 -83 -49 -15 -267 -16
-2159 -14 l-2105 3 -56 26 c-73 34 -134 91 -165 151 -43 85 -83 78 453 78 476
0 477 0 500 22 23 21 30 67 17 103 -17 43 -38 45 -539 45 l-475 0 2 2048 3
2047 28 56 c45 92 135 165 232 190 17 4 982 6 2145 6 l2115 -2 56 -28z"/>
<path d="M509 4667 c-18 -12 -44 -38 -56 -56 l-23 -34 0 -1159 c0 -978 2
-1163 14 -1186 20 -38 65 -77 105 -91 48 -16 3953 -16 4016 0 48 12 110 70
120 111 3 13 4 544 3 1180 -3 1156 -3 1157 -24 1185 -11 15 -36 38 -54 51
l-33 22 -2017 0 -2017 0 -34 -23z m4011 -827 l0 -680 -124 0 -125 0 -3 278
c-3 309 -5 316 -75 369 l-36 28 -232 0 -232 0 -36 -28 c-70 -53 -72 -60 -75
-369 l-3 -278 -125 0 -124 0 0 268 c0 238 -2 271 -19 307 -21 46 -54 79 -94
94 -17 7 -112 11 -231 11 -189 0 -204 -1 -246 -22 -25 -13 -55 -38 -67 -57
-23 -33 -23 -40 -23 -317 l0 -284 -130 0 -130 0 0 270 c0 294 -3 312 -56 362
-47 44 -73 48 -287 48 -228 0 -263 -9 -308 -71 -24 -34 -24 -36 -27 -321 l-3
-288 -129 0 -130 0 0 273 c0 267 -1 275 -23 317 -16 30 -37 51 -67 67 -41 22
-53 23 -250 23 -197 0 -209 -1 -251 -23 -27 -15 -52 -38 -66 -63 -22 -38 -23
-48 -23 -316 l0 -278 -85 0 -85 0 0 680 0 680 1960 0 1960 0 0 -680z m-3240
-442 c0 -306 5 -332 71 -379 32 -23 42 -24 217 -27 170 -3 185 -2 220 18 20
12 49 37 62 57 25 36 25 37 28 320 l3 283 170 0 169 0 0 -276 c0 -308 2 -322
68 -372 35 -27 38 -27 215 -30 123 -2 189 0 208 9 40 16 86 71 98 116 6 22 11
147 11 296 l0 257 170 0 169 0 3 -289 c3 -274 4 -291 24 -317 49 -66 58 -69
262 -72 182 -3 188 -2 221 20 77 52 75 47 81 366 l5 287 173 3 172 2 0 -283
c0 -279 0 -285 23 -318 12 -18 38 -44 56 -56 32 -21 44 -23 187 -23 l154 0 0
-345 0 -345 -1960 0 -1960 0 0 345 0 345 108 0 c129 0 171 18 209 89 22 43 23
51 23 318 l0 273 170 0 170 0 0 -272z"/>
<path d="M2702 1934 c-188 -94 -186 -356 3 -457 63 -34 164 -30 233 7 231 128
141 475 -124 476 -45 0 -73 -6 -112 -26z m173 -169 c35 -34 33 -78 -4 -116
-18 -17 -40 -29 -56 -29 -32 0 -85 50 -85 80 0 78 91 119 145 65z"/>
<path d="M760 1783 c-14 -3 -53 -18 -88 -33 -83 -38 -163 -119 -205 -207 -30
-64 -32 -75 -32 -178 0 -99 3 -116 28 -169 92 -197 295 -294 502 -240 248 64
384 349 276 580 -57 121 -141 198 -260 235 -59 18 -158 23 -221 12z m203 -188
c49 -23 92 -66 120 -119 30 -57 30 -165 0 -221 -101 -190 -363 -192 -457 -3
-67 134 -1 302 140 354 50 18 148 13 197 -11z"/>
<path d="M1747 1771 c-153 -50 -261 -178 -289 -340 -52 -301 245 -562 538
-473 125 38 210 111 268 232 29 61 31 72 31 175 0 103 -2 114 -32 177 -44 93
-110 160 -199 205 -65 32 -84 36 -166 39 -72 3 -106 0 -151 -15z m205 -161
c57 -16 119 -69 150 -129 71 -136 4 -306 -141 -356 -121 -41 -251 12 -314 130
-30 56 -30 164 0 221 27 50 100 117 145 131 44 14 114 15 160 3z"/>
<path d="M3355 1765 c-17 -16 -25 -35 -25 -57 1 -70 38 -88 175 -88 104 0 107
1 136 29 31 31 36 59 17 94 -22 42 -38 46 -161 47 -112 0 -119 -1 -142 -25z"/>
<path d="M3882 1783 c-17 -6 -42 -57 -42 -83 0 -12 13 -35 29 -51 29 -29 31
-29 141 -29 110 0 112 0 141 29 37 38 39 82 4 116 -23 24 -30 25 -142 24 -65
0 -124 -3 -131 -6z"/>
<path d="M4375 1758 c-32 -38 -29 -81 11 -115 23 -21 35 -23 130 -23 109 0
155 13 168 45 13 35 6 76 -19 100 -23 24 -30 25 -144 25 l-119 0 -27 -32z"/>
<path d="M3355 1425 c-25 -24 -32 -65 -19 -100 13 -33 59 -45 169 -45 104 0
107 1 136 29 17 18 29 40 29 56 0 16 -12 38 -29 56 -29 29 -31 29 -146 29
-110 0 -117 -1 -140 -25z"/>
<path d="M3884 1438 c-24 -11 -44 -48 -44 -79 0 -11 13 -34 29 -50 29 -28 32
-29 136 -29 106 0 138 8 162 39 22 28 15 76 -13 105 -26 25 -31 26 -138 25
-61 0 -121 -5 -132 -11z"/>
<path d="M4379 1421 c-17 -18 -29 -40 -29 -56 0 -16 12 -38 29 -56 29 -29 31
-29 146 -29 110 0 117 1 140 25 17 16 25 35 25 60 0 25 -8 44 -25 60 -23 24
-30 25 -140 25 -115 0 -117 0 -146 -29z"/>
<path d="M2750 1271 c-46 -15 -85 -39 -116 -73 -52 -55 -68 -95 -69 -173 0
-80 19 -128 72 -181 56 -56 89 -69 178 -69 70 0 86 4 128 28 55 33 102 93 118
151 14 51 6 143 -15 184 -23 44 -76 95 -122 117 -43 21 -135 29 -174 16z m103
-173 c78 -41 52 -159 -35 -158 -37 1 -59 14 -76 47 -19 35 -14 63 17 94 31 31
59 36 94 17z"/>
<path d="M3375 1098 c-51 -29 -61 -93 -20 -133 23 -24 30 -25 142 -25 123 1
139 5 161 47 19 35 14 63 -17 94 -29 29 -31 29 -138 29 -62 0 -116 -5 -128
-12z"/>
<path d="M3869 1081 c-31 -31 -36 -59 -17 -94 22 -42 38 -46 161 -47 112 0
119 1 142 25 17 16 25 35 25 57 -1 70 -38 88 -175 88 -104 0 -107 -1 -136 -29z"/>
<path d="M4379 1081 c-17 -18 -29 -40 -29 -56 0 -16 12 -38 29 -56 29 -29 31
-29 146 -29 110 0 117 1 140 25 25 24 32 65 19 100 -13 33 -59 45 -169 45
-104 0 -107 -1 -136 -29z"/>
    </g>
  </svg>
);

export default SvgOscilloscope;
